import React, { useState } from 'react';

import IconButton, { IconButtonProps } from '@material-ui/core/IconButton';
import { get } from 'lodash';

import { useLumaBotContext } from '../LumaBot.context';

import MenuActions from './MenuActions';

export interface IconButtonActionsProps extends Omit<IconButtonProps, 'classes' | 'onClick'> {}

const IconButtonActions: React.FC<IconButtonActionsProps> = ({ ...rest }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [menuListWidth, setMenuListWidth] = useState();
  const { shouldDisableHeaderMenuActions } = useLumaBotContext();

  return (
    <>
      <IconButton
        aria-label="More"
        aria-owns={anchorEl ? 'MenuActions' : undefined}
        aria-haspopup="true"
        onClick={(event) => {
          setMenuListWidth(get(event, 'currentTarget.parentElement.offsetWidth'));
          setAnchorEl(event.currentTarget.parentElement);
        }}
        disabled={shouldDisableHeaderMenuActions}
        {...rest}
      />
      <MenuActions
        id="MenuActions"
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        MenuListProps={{
          disablePadding: true,
          style: {
            width: menuListWidth,
          },
        }}
      />
    </>
  );
};

export default IconButtonActions;
